import axios from "axios";
import * as appConstants from "../constants/index";
import successIcon from "../assets/googlewallet/successicon.svg";
import errorIcon from "../assets/googlewallet/erroricon.svg";
import infoicon from "../assets/googlewallet/infoicon.svg";


export const verifyWithGoogleWallet = async (theme) => {
  try {
    const headers = {
      Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
      chain: theme === "inoxTheme" ? "INOX" : "PVR",
      city: localStorage.getItem("city") || "defaultCity",
      appVersion: appConstants.av,
      platform: appConstants.pt,
      country: appConstants.cname,
      "Content-Type": "application/json",
    };

    const initiateRes = await axios.post(`${appConstants.base_url}v1/wallet/initiate`, {}, { headers });

    if (initiateRes?.data?.result !== "success") throw new Error("Session creation failed");

    const { sessionId, requestJson } = initiateRes.data.output;

    if (!sessionId || !requestJson) throw new Error("Invalid initiate response");

    const credentialResponse = await navigator.credentials.get({ digital: requestJson });

    if (!credentialResponse) return { cancelled: true };

    const payload = {
      sessionId,
      encryptedJwt: typeof credentialResponse === "string" ? credentialResponse : JSON.stringify(credentialResponse),
    };

    const verifyRes = await axios.post(`${appConstants.base_url}v1/wallet/verify`, payload, { headers });

    if (verifyRes?.data?.result === "success") {
      sessionStorage.setItem("googleverifybtn", "true");
      return { success: "success", title: verifyRes.data?.output?.msg, msg: verifyRes.data?.msg, icon: successIcon, subMsg: verifyRes.data?.output?.offer_text, button_text:verifyRes.data?.output?.button_text};
    } else if(verifyRes?.data?.result === "dialog"){
    return { success: "dialog", title: verifyRes.data?.output?.msg, msg: verifyRes.data?.output?.error_text,subMsg: verifyRes.data?.output?.offer_text, icon: infoicon, button_text: "Okay" };
    }
    
    else {
      throw new Error(verifyRes?.data?.msg || "Verification failed");
    }
  } catch (error) {
    if (error.name === "NotAllowedError") return { cancelled: true };
    return {
      success: "error",
      title: "Verification incomplete",
      msg: "Google couldn’t complete your verification due to a temporary issue" || error?.message || "Something went wrong.",
      icon: errorIcon,
      subMsg: "You can verify anytime from your profile to unlock personalised offers.",
      button_text:"Try Again"
    };
  }
};